import { Type } from "@scalar/typebox";
const XScalarStabilityValues = {
  Deprecated: "deprecated",
  Experimental: "experimental",
  Stable: "stable"
};
const XScalarStabilitySchema = Type.Object({
  "x-scalar-stability": Type.Optional(
    Type.Union([Type.Literal("deprecated"), Type.Literal("experimental"), Type.Literal("stable")])
  )
});
export {
  XScalarStabilitySchema,
  XScalarStabilityValues
};
//# sourceMappingURL=x-scalar-stability.js.map
